export default __webpack_public_path__ + "static/media/dev-juan-03.c5dd4ec1.jpg";